import { render, staticRenderFns } from "./05.vue?vue&type=template&id=65898771&scoped=true&"
import script from "./05.vue?vue&type=script&lang=js&"
export * from "./05.vue?vue&type=script&lang=js&"
import style0 from "./05.vue?vue&type=style&index=0&id=65898771&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65898771",
  null
  
)

export default component.exports